<template>
	<div>
		<el-row style="border-bottom: 1px solid #ebeef5;padding-bottom: 20px;background-color: blue;width: 1350px">
			<el-col :span="4"></el-col>
			<el-col :span="14" style="text-align: center;">
				<div style="font-size: 30px; font-weight: bold;vertical-align: center;color: white">中级消防设施操作员[操作题]练习
					{{ paperInfo.name }}
				</div>
				<div style="font-size: 16px; color: gray;vertical-align: center;color: white">
					题目类型:{{ paperDetailInfo.name }}
					第{{ questionNumber }}题/共{{ paperDetailInfo.totalCount }}题
					答题时间:{{ paperDetailInfo.limitTime }}分钟
				</div>
			</el-col>
			<el-col :span="6">
				<el-menu mode="horizontal">
					<el-sub-menu index="1">
						<template #title>
							<div style="font-size: 20px;border-bottom-color: transparent;">欢迎 {{ loginNickName }}</div>
						</template>
						<el-menu-item @click="handleToPage('/')" index="home">首页</el-menu-item>
						<el-menu-item v-if="!isBuy"
							@click="handleToTryPractice('/fire/try/practice/theoryMediumDevice','try', 'practice','theory')"
							index="theoryPracticeTry">理论练习</el-menu-item>
						<el-menu-item v-if="!isBuy"
							@click="handleToTryPractice('/fire/try/exam/theoryMediumDevice','try', 'exam','theory')"
							index="theoryExamTry">模拟理论考试</el-menu-item>
						<el-menu-item v-if="!isBuy"
							@click="handleToTryPractice('/fire/try/practice/peopleMediumDevice','try', 'practice','people')"
							index="peoplePracticeTry">操作题练习</el-menu-item>
						<el-menu-item v-if="!isBuy"
							@click="handleToTryPractice('/fire/try/exam/peopleMediumDevice','try', 'exam','people')"
							index="peoplePracticeTry">操作题考试</el-menu-item>
						<el-menu-item v-if="isBuy"
							@click="handleToTryPractice('/fire/normal/practice/theoryMediumDevice','normal', 'practice','theory')"
							index="theoryPractice">理论练习</el-menu-item>
						<el-menu-item v-if="isBuy"
							@click="handleToTryPractice('/fire/normal/exam/theoryMediumDevice','normal', 'exam','theory')"
							index="theoryExam">模拟理论考试</el-menu-item>
						<el-menu-item v-if="isBuy"
							@click="handleToTryPractice('/fire/normal/practice/peopleMediumDevice','normal', 'practice','people')"
							index="peoplePractice">操作题练习</el-menu-item>
						<el-menu-item v-if="isBuy"
							@click="handleToTryPractice('/fire/normal/exam/peopleMediumDevice','normal', 'exam','people')"
							index="peopleExam">操作题考试</el-menu-item>

					</el-sub-menu>
				</el-menu>
			</el-col>
		</el-row>

		<div :style="{ backgroundImage: `url(${this.backgroundImg})`}" class="room-div">
			<div>
				<audio ref="questionAudioPlayer" autoplay></audio>
			</div>

			<div class="div-pre-modify-bordered-item"
				v-for="(preModifyItem, index) in paperContentInfo.questionPreModifyDtoList"
				:style=preModifyItem.divStyle :key="index">

				<img v-if="preModifyItem.imageStyle!== null" :style=preModifyItem.imageStyle
					:src="`/view/FireEngine/picture${preModifyItem.imagePath}`" alt="light">

				<!--        <div>-->
				<!--          <el-image :src=require("@/assets/picture/FireEngine"+preModifyItem.imagPath)></el-image>-->
				<!--        </div>-->
				<div v-if="preModifyItem.text!== null" :style="preModifyItem.textStyle">{{preModifyItem.text}}</div>
				<img v-if="preModifyItem.gifStyle!== null &&showGif===true" :style=preModifyItem.gifStyle
					:src="`/view/FireEngine/picture${preModifyItem.imagePath}`" alt="gif" @load="closeGif">
				<!--        <audio v-if="preModifyItem.audioStyle!==null" ref="preModifyAudioPlayer" autoplay></audio>-->

			</div>

			<div class="div-operation-bordered-item"
				v-for="(operationItem, index) in paperContentInfo.questionOperationDtoList"
				:style=operationItem.divStyle :key="index" @click="operationClick(operationItem)">

				<img v-if="operationItem.imageStyle!== null" :style=operationItem.imageStyle
					:src="`/view/FireEngine/picture${operationItem.imagePath}`" alt="opt">
				<audio v-if="operationItem.audioStyle!==null" ref="operationAudioPlayer" autoplay></audio>
				<!--        <div>-->
				<!--          <el-image :src=require("@/assets/picture/FireEngine"+preModifyItem.imagPath)></el-image>-->
				<!--        </div>-->

			</div>

			<div class="div-recognize-bordered-item"
				v-for="(recognizeItem, index) in paperContentInfo.questionRecognizeDtoList" :style="recognizeItem.style"
				:key="index" :class="{ 'div-recognize-selected': selectedRecognizeItem === recognizeItem }"
				@click="selectBoxAsAnswer(recognizeItem)">

				<!--      <div class="div-recognize-bordered-item" style="width: 150px;height: 50px;top: 38%; left: 67.5%"-->
				<!--      @click="selectBoxAsAnswer(1)" :class="{ 'selected': selectedItem === id }">-->

			</div>

			<el-dialog v-model="isRecording" title="开始答题" append-to-body style="width: 320px">
				<recordComponent @submitRecord:value="submitRecording"></recordComponent>
			</el-dialog>
			<div class="draggable">
				{{ questionNumber }}.{{paperContentInfo.question}}({{paperContentInfo.label}})
				<img style="width: 20px;height: 20px" src="@/assets/picture/sound.png" alt="sound"
					@click="playQuestionAudio">
				<div v-if="paperContentInfo.type==='recognize'||paperContentInfo.type==='operation'"
					style="background-color: lightgray;border-bottom-left-radius:10px;border-bottom-right-radius:10px;width:250px">
					<el-radio-group v-for="(answerInfo,index) in paperContentInfo.questionAnswerDtoList" :key="index"
						v-model="userAnswer"
						style="display: flex; flex-direction: column; align-items: flex-start;margin-left: 5px;margin-top: 20px">
						<el-radio :label="answerInfo.alphabet" @click="getCurrentChoice(answerInfo)">
							{{ answerInfo.alphabet }}.{{ answerInfo.content }}&nbsp;&nbsp;
						</el-radio>
					</el-radio-group>
				</div>
				<div v-if="paperContentInfo.type==='oral'" style="display: flex;flex-wrap: wrap; ">
					<el-checkbox-group style="margin-right: 10px;" v-model="selectedAnswers">
						<el-checkbox :label="answerInfo" :value="answerInfo"
							v-for="answerInfo in paperContentInfo.questionAnswerDtoList" :key="answerInfo.id">
							{{ answerInfo.alphabet }}.{{ answerInfo.content }}
						</el-checkbox>
					</el-checkbox-group>
				</div>
			</div>
			<div style="position: fixed;top: 95%;width: 100%;">
				<el-button type="primary" style="float:right;margin-right: 20px" @click="goBack()">返回</el-button>
				<!--        <el-button type="warning" style="float:right;margin-right: 20px" @click="getCurrentQuestion()">重做</el-button>-->
				<el-button type="primary"
					v-if="questionNumber<=paperDetailInfo.totalCount&&paperContentInfo.type==='oral' && currentStepId === totalStepCount"
					style="float:right;margin-right: 20px" @click="startRecording">语音答题</el-button>
				<el-button type="primary"
					v-if="questionNumber<=paperDetailInfo.totalCount && paperContentInfo.type!=='oral'"
					style="float:right;margin-right: 20px" @click="submitAnswer()">提交</el-button>
				<!--        <el-button type="primary" v-if="currentStepId<totalStepCount" style="float:right;margin-right: 20px">下一步</el-button>-->
			</div>
		</div>
	</div>


</template>

<script>
	import {
		useRoute
	} from "vue-router/dist/vue-router";
	import request from "@/utils/request";
	import {
		ElMessage,ElMessageBox
	} from "element-plus";
	import router from "@/router";
	import {
		ref
	} from "vue";
	import recordComponent from "@/components/Record";


	const loginNickName = localStorage.getItem("loginNickName");
	const loginUserId = localStorage.getItem("loginUserId");

	const questionNumber = ref(1);
	let beginExamTime = new Date();

	// const hasSelected = ref(false);

	const percentage = ref(0);
	const paperTotalCount = ref(0);
	const questionType = ref('');
	const isBuy = ref(false);
	const paperFontSize = ref('18px');
	const backgroundImg = ref('');
	// const soundPath=ref('');

	const currentStepId = ref(1);
	const totalStepCount = ref(1);
	const paperStatus = ref('');
	const subjectId = ref('');


	async function uploadNewQuestionRecord() {
		const formData = new FormData();
		formData.append("file", this.recBlob, Date.now() + ".mp3");
		formData.append("userId", loginUserId);
		// formData.append("paperId",paperId);
		formData.append("id", paperContentInfo.value.id);

		await request.post('/userQuestionInfo/oral', formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}).then(response => {
			const result = response.data; // 将接口返回的数据赋值给result
			if (result.code === "200") {
				this.oralStatus = "recognizing";
			} else {
				ElMessage.warning(result.msg);
			}
		}).catch(error => {
			console.log("uploadNewQuestionRecord error:" + error);
			// ElMessage.error("系统异常，请联系管理员");
		});
	}

	function getOperationInfo(questionId, stepId) {
		request.get('/questionOperationInfo/questionId/step', {
				params: {
					userId: loginUserId,
					questionId: questionId,
					stepId: stepId
				}
			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					this.paperContentInfo.questionOperationDtoList = result.data;
				} else {
					ElMessage.warning(result.msg);
					router.push("/login");
				}
			})
			.catch(error => {
				console.log("TheoryMediumDevice error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}

	function getPreModifyInfo(questionId, stepId) {
		request.get('/questionPreModifyInfo/questionId/step', {
				params: {
					userId: loginUserId,
					questionId: questionId,
					stepId: stepId
				}
			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					this.paperContentInfo.questionPreModifyDtoList = result.data;
				} else {
					ElMessage.warning(result.msg);
					router.push("/login");
				}
			})
			.catch(error => {
				console.log("TheoryMediumDevice error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}

	function getUserAuthorization(paperId) {
		request.get('/userAuthorization/check', {
				params: {
					userId: loginUserId,
					paperId: paperId,
					type: "subject"
				}
			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					isBuy.value = result.data.checked;
				} else {
					ElMessage.warning(result.msg);
					router.push("/login");
				}
			})
			.catch(error => {
				console.log("TheoryMediumDevice error:" + error);
				ElMessage.error("请重新登录");
				router.push("/login");
			});
	}

	async function getPaperContentInfoBySubjectId(subjectId, questionNumberId) {
		await request.get('/paperContentInfo/subjectId/one', {
				params: {
					userId: loginUserId,
					subjectId: subjectId,
					questionNumber: questionNumberId
				}
			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					paperContentInfo.value = result.data;
					questionId.value = paperContentInfo.value.id;
					questionType.value = paperContentInfo.value.type;
					getRelativeInfo("active");
				} else {
					ElMessage.warning(result.msg);
				}
			})
			.catch(error => {
				console.log("TheoryMediumDevice error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}


	async function getRelativeInfo(type) {
		questionId.value = paperContentInfo.value.id;
		questionTypePlayer.value.src = require("@/assets/sound/" + paperContentInfo.value.type + ".mp3");
		questionTypePlayer.value.play();
		if (paperContentInfo.value.imagePath !== '') {
			if (type === "userQuestion") {
				backgroundImg.value = 'view' + paperContentInfo.value.imagePath;
			} else {
				backgroundImg.value = 'view/FireEngine/picture' + paperContentInfo.value.imagePath;
			}
		}
		if (paperContentInfo.value.soundPath !== null && paperContentInfo.value.soundPath !== "") {
			if (type === "userQuestion") {
				questionAudioPlayer.value.src = 'view' + paperContentInfo.value.soundPath;
			} else {
				questionAudioPlayer.value.src = 'view/FireEngine' + paperContentInfo.value.soundPath;
			}
			setTimeout(() => {
				questionAudioPlayer.value.play()
			}, 2000);
		}
		if (paperContentInfo.value.questionOperationDtoList !== null && paperContentInfo.value.questionOperationDtoList
			.length > 0) {
			totalStepCount.value = paperContentInfo.value.questionOperationDtoList[0].totalStepCount;
		}
		if (paperContentInfo.value.label === 'require') {
			paperContentInfo.value.label = '必考题';
		}
		if (paperContentInfo.value.label === 'choose') {
			paperContentInfo.value.label = '抽考题';
		}
	}

	async function getPaperInfo(paperId) {
		await request.get('/paperInfo/paperId', {
				params: {
					userId: loginUserId,
					paperId: paperId
				}
			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					this.paperInfo = result.data;
				} else {
					ElMessage.warning(result.msg);
				}
			})
			.catch(error => {
				console.log("TheoryMediumDevice error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}


	async function getPaperDetailInfo(paperId, paperType) {
		await request.get('/paperDetailInfo/type', {
				params: {
					userId: loginUserId,
					paperId: paperId,
					paperType: paperType
				}
			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					this.paperDetailInfo = result.data;
					paperTotalCount.value = this.paperDetailInfo.totalCount;
				} else {
					ElMessage.warning(result.msg);
				}
			})
			.catch(error => {
				console.log("paperDetailInfo error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}

	async function uploadRecord() {
		const formData = new FormData();
		formData.append("file", this.recBlob, Date.now() + ".mp3");
		formData.append("userId", loginUserId);
		formData.append("paperId", paperId.value);
		formData.append("questionId", paperContentInfo.value.id);
		formData.append("areaId", areaId.value);
		formData.append("questionNumber", questionNumber.value);
		formData.append("examId", examId.value);

		await request.post('/paperContentQuestionInfo/oral', formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}).then(response => {
			const result = response.data; // 将接口返回的数据赋值给result
			if (result.code === "200") {
				this.oralStatus = "recognizing";
			} else {
				ElMessage.warning(result.msg);
			}
		}).catch(error => {
			console.log("uploadRecord error:" + error);
			// ElMessage.error("系统异常，请联系管理员");
		});
	}

	async function updatePaperContentQuestionInfoByExam(paperId) {
		request.put('/paperContentQuestionInfo/exam', {
				"userId": loginUserId,
				"selectedAnswers": selectedQuestions.value,
				"paperId": paperId,
				"type": "people",
				"usedTime": new Date().getTime() - beginExamTime.getTime()
			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					this.oralStatus = "recognizing";
				} else {
					ElMessage.warning(result.msg);
				}
			})
			.catch(error => {
				console.log("TheoryMediumDevice error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}


	async function updateUserQuestionByExam(paperId, examId) {
		request.put('/userQuestionInfo/exam', {
				"userId": loginUserId,
				"selectedAnswers": selectedQuestions.value,
				"paperId": paperId,
				"examId": examId,
				"type": "people",
				"usedTime": new Date().getTime() - beginExamTime.getTime()
			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code !== "200") {
					ElMessage.warning(result.msg);
				}
			})
			.catch(error => {
				console.log("TheoryMediumDevice error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}

	async function submitExamInfos() {
		request.post('/examInfo/', {
				"userId": loginUserId,
				"selectedAnswers": selectedQuestions.value,
				"paperId": examId.value,
				"type": "people",
				"usedTime": new Date().getTime() - beginExamTime.getTime()
			}, {
				headers: {
					'Content-Type': 'application/json;charset=utf-8'
				}
			})
			.then(async response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					await updatePaperContentQuestionInfoByExam.call(this, examId.value);
					await updateUserQuestionByExam.call(this, examId.value, result.data.examId);
					selectedQuestions.value = [];
					await router.push({
						path: "/fire/ExamScore",
						query: {
							examId: result.data.examId,
							examType: "people",
							paperId: paperId.value,
							areaId: areaId.value,
							paperStatus: paperStatus.value,
							subjectId: subjectId.value
						}
					});
				} else {
					ElMessage.warning(result.msg);
					await router.push("/login");
				}
			})
			.catch(error => {
				console.log("TheoryMediumDevice error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}
	const chooseAnswerInfo = ref({
		questionId: '',
		answer: false,
		alphabet: '',
		correctAnswerAlphabet: ''
	});

	const selectedAnswers = ref([]);
	const selectedQuestions = ref([]);

	const selectedRecognizeItem = ref(null);
	const selectedOperationItem = ref(null);


	const questionAudioPlayer = ref(new Audio());
	const questionTypePlayer = ref(new Audio());

	const showGif = ref(true);

	function closeGif() {
		showGif.value = false;
	}


	// const preModifyAudioPlayer = ref(null);
	// const preModifySoundPath=ref('');

	const paperContentInfo = ref('');

	const operationAudioPlayer = ref(new Audio());
	// const operationSoundPath=ref('');
	const isRecording = ref(false);
	const hasRecord = ref(false);
	const recordPlayer = ref(new Audio());
	const recordUrl = ref('');

	const areaId = ref('');
	const paperId = ref('');
	const questionId = ref(0);
	const examId = ref('');
	// const currentVolume = ref(0);

	export default {
		name: "peoplePaperExam",
		components: {
			recordComponent
		},
		data() {
			return {
				loginNickName: loginNickName,
				paperInfo: '',
				paperDetailInfo: '',
				paperContentInfo: paperContentInfo,
				userAnswer: '',
				selectedAnswers: selectedAnswers,
				chooseAnswerInfo: chooseAnswerInfo,
				// hasSelected: hasSelected,
				questionNumber: questionNumber,
				percentage: percentage,
				isBuy: isBuy,
				backgroundImg: backgroundImg,
				selectedRecognizeItem: selectedRecognizeItem,
				paperFontSize: paperFontSize,
				currentStepId: currentStepId,
				totalStepCount: totalStepCount,
				selectedOperationItem: selectedOperationItem,
				// soundPath:soundPath,
				questionAudioPlayer: questionAudioPlayer,
				showGif: showGif,
				isRecording: isRecording,
				hasRecord: hasRecord,
				recordPlayer: recordPlayer,
				recordUrl: recordUrl,
				recBlob: "",
				oralScore: 0,
				paperId: paperId,
				areaId: areaId,
				questionId: questionId,
				questionType: questionType,
				oralStatus: "init",

				// mediaRecorder:new Recorder(),
			}
		},
		async created() {
			const route = useRoute()
			areaId.value = route.query.areaId
			paperId.value = route.query.paperId
			questionNumber.value = parseInt(route.query.questionNumber, 10);
			paperStatus.value = route.query.paperStatus;
			questionType.value = route.query.questionType;
			examId.value = route.query.examId;

			this.getUserAuthorization(route.query.paperId);
			await this.getPaperInfo(examId.value);

			if (paperStatus.value === 'active') {
				await getPaperDetailInfo.call(this, paperId.value, 'exam')
				subjectId.value = this.paperInfo.examId;
				await getPaperContentInfoBySubjectId.call(this, subjectId.value, questionNumber.value);
			}

			this.userAnswer = null;
			selectedAnswers.value = [];
		},
		methods: {
			handleToPage(path) {
				router.push(path);
			},
			handleToTryPractice(trainPath, buyMode, studyMode, subjectType) {
				router.push({
					path: trainPath,
					query: {
						areaId: areaId.value,
						studyMode: studyMode,
						buyMode: buyMode,
						subjectType: subjectType
					}
				});
			},
			getUserAuthorization(paperId) {
				getUserAuthorization.call(this, paperId)
			},
			async getPaperInfo(paperId) {
				await getPaperInfo.call(this, paperId);
			},
			async getPaperDetailInfo(paperId, questionType) {
				await getPaperDetailInfo.call(this, paperId, questionType);
			},
			getCurrentChoice(answerInfo) {
				chooseAnswerInfo.value = answerInfo;
				const selectedQuestion = selectedQuestions.value.find(item => item.questionNumber === questionNumber
					.value);
				if (selectedQuestion) {
					selectedQuestion.correct = answerInfo.answer;
					selectedQuestion.answerInfos = [answerInfo];
				} else {
					selectedQuestions.value.push({
						"questionId": questionId.value,
						"questionNumber": questionNumber.value,
						"correct": answerInfo.answer,
						"answerInfos": [answerInfo],
						"type": questionType.value,
						"paperId": paperId.value
					});
				}
				percentage.value = Math.floor((selectedQuestions.value.length / paperTotalCount.value) * 100);
			},
			getNextQuestion() {
				questionNumber.value = questionNumber.value + 1;
				this.getPaperContentInfoByStatus();
			},
			getPaperContentInfoByStatus() {
				this.userAnswer = null;
				this.selectedAnswers.value = [];
				chooseAnswerInfo.value = {
					questionId: '',
					answer: false,
					alphabet: '',
					correctAnswerAlphabet: ''
				};
				// hasSelected.value = false;
				selectedRecognizeItem.value = [];
				selectedOperationItem.value = [];
				currentStepId.value = 1;
				totalStepCount.value = 1;
				if (this.paperInfo.status === 'active') {
					getPaperContentInfoBySubjectId.call(this, subjectId.value, questionNumber.value);
				}
			},
			selectBoxAsAnswer(item) {
				selectedRecognizeItem.value = item;
        currentStepId.value=2;
      },
			submitAnswer() {
				let answerResult = false;
				if (questionType.value === 'recognize') {
					if (selectedRecognizeItem.value !== null && selectedRecognizeItem.value !== undefined && Object.keys(
							selectedRecognizeItem.value).length > 0) {
						if (selectedRecognizeItem.value.answer) {
							answerResult = true;
						}
					}
				}

				if (chooseAnswerInfo.value.questionId !== '') {
					if (chooseAnswerInfo.value.answer) {
						answerResult = true;
					}
				}

				if (questionType.value === 'operation') {
					if (selectedOperationItem.value !== null && selectedOperationItem.value !== undefined && Object.keys(
							selectedOperationItem.value).length >= totalStepCount.value) {
						answerResult = true;
					}
				}

				const selectedQuestion = selectedQuestions.value.find(item => item.questionNumber === questionNumber
					.value);
				if (selectedQuestion) {
					selectedQuestion.correct = answerResult;
				} else {
					selectedQuestions.value.push({
						"questionId": questionId.value,
						"questionNumber": questionNumber.value,
						"correct": answerResult,
						"answerInfos": [],
						"type": questionType.value,
						"paperId": paperId.value
					});
				}
				if (questionNumber.value >= paperTotalCount.value) {
          ElMessageBox.alert('正在提交试卷，计算的得分中...', '', {
                // confirmButtonText: '确定',
                type: "success",
                center: true,
              }
          );
          setTimeout(() => {
            this.$msgbox.close();
            submitExamInfos.call()
          }, 10000);
				} else {
					this.getNextQuestion();
				}
			},
			operationClick(operationItem) {
				showGif.value = true;
				if (operationItem.methodName === 'playAudio') {
					operationAudioPlayer.value.src = require(`@/assets/sound${operationItem.imagePath}`);
					operationAudioPlayer.value.play();
					this.switchoverPreModify(operationItem);
				}
				if (operationItem.methodName === 'switchoverPreModify') {
					operationAudioPlayer.value.pause();
					this.switchoverPreModify(operationItem)
				}
			},
			switchoverPreModify(operationItem) {
				if (currentStepId.value !== operationItem.nextStepId) {
					getPreModifyInfo.call(this, operationItem.questionId, operationItem.nextStepId);
					if (operationItem.nextStepId < totalStepCount.value) {
						getOperationInfo.call(this, operationItem.questionId, operationItem.nextStepId);
					}
					currentStepId.value = operationItem.nextStepId;
				}
				selectedOperationItem.value = operationItem;
			},
			playQuestionAudio() {
				if (questionAudioPlayer.value != null) {
					questionAudioPlayer.value.play();
				}
			},
			goBack() {
				if (isBuy.value) {
					this.handleToTryPractice('/fire/normal/exam/peopleMediumDevice', 'normal', 'exam', 'people');
				} else {
					this.handleToTryPractice('/fire/try/exam/peopleMediumDevice', 'try', 'exam', 'people');
				}
			},
			closeGif() {
				setTimeout(closeGif, 6000);
			},

			startRecording() {
				isRecording.value = true;
			},

			async submitRecording(value) {
				isRecording.value = false;
				if (value != null) {
					this.recBlob = value;
					const selectedQuestion = selectedQuestions.value.find(item => item.questionNumber ===
						questionNumber.value);
					if (selectedQuestion) {
						selectedQuestion.correct = false;
					} else {
						selectedQuestions.value.push({
							"questionId": questionId.value,
							"questionNumber": questionNumber.value,
							"correct": false,
							"answerInfos": [],
							"type": questionType.value,
							"paperId": paperId.value
						});
					}
					if (this.paperInfo.status === 'active') {
						await uploadRecord.call(this);
					}
					if (this.paperInfo.status === 'userDefine') {
						await uploadNewQuestionRecord.call(this);
					}
					if (this.oralStatus === 'recognizing') {
						ElMessage.success("回答完成");
					}
					if (questionNumber.value >= paperTotalCount.value) {
            ElMessageBox.alert('正在提交试卷，计算的得分中...', '', {
                  // confirmButtonText: '确定',
                  type: "success",
                  center: true,
                }
            );
            setTimeout(() => {
              this.$msgbox.close();
              submitExamInfos.call()
            }, 10000);
					} else {
						this.getNextQuestion();
					}
				}
			}
		}
	}
</script>
<style scoped>
	.mode-col {
		height: 300px;
		width: 400px;
		/* 设置一个高度让背景显示出来 */
		background-size: contain;
		background-repeat: no-repeat;
		/* 背景图片覆盖整个元素 */
		transition: background-image 0.5s;
		/* 可选的，背景图变化过渡效果 */
		/*align-content: center;*/
		/*background-color: lightgray;*/
	}

	.room-div {
		/*background-image: v-bind(backgroundImg);*/
		background-size: cover;
		background-repeat: no-repeat;
		background-position: center;
		background-position-y: 0;
		background-position-x: 0;
		height: 670px;
		width: 1350px;
		position: absolute;
	}

	.el-menu {
		background-color: transparent;
		border-bottom-color: transparent;
	}

	.el-menu-item {
		background-color: transparent !important;
		color: black !important;
		font-weight: 50;
		width: 200px;
		font-size: 18px;
		text-align: center;

		&:not(.is-disabled):hover {
			color: gray !important;
			background-color: lightgray !important;
			width: 200px;
			text-align: center;
		}
	}

	.content {
		flex: 1;
		/* 让内部容器充满剩余空间 */
		display: flex;
		/*align-items: center; !* 垂直居中 *!*/
		justify-content: flex-start;
		/* 水平方向从左边开始排列 */
	}

	.el-radio :deep(.el-radio__label) {
		font-size: v-bind(paperFontSize);
		line-height: 2;
		color: black;
		/*margin-right: 15px;*/
		white-space: normal;
		word-break: break-all;
	}

	.el-radio :deep(.el-radio__inner) {
		width: v-bind(paperFontSize);
		height: v-bind(paperFontSize);
		border-color: black;
	}

	.el-radio :deep(.el-radio__input.is-checked + .el-radio__label) {
		color: black;
	}

	.el-radio :deep(.el-radio__input.is-checked .el-radio__inner) {
		border-color: blue;
		/* 选中边框的颜色 */
		background-color: blue;
		/* 选中背景的颜色 */
	}

	.el-checkbox :deep(.el-checkbox__label) {
		font-size: v-bind(paperFontSize);
		/* 这里设置你想要的字体大小 */
		overflow: hidden;
		white-space: normal;
		word-break: break-all;
		color: black;
	}

	.el-checkbox :deep(.el-checkbox__input.is-checked + .el-checkbox__label) {
		color: black;
		/* 替换为你想要的颜色 */
	}

	.el-checkbox :deep(.el-checkbox__inner) {
		width: 16px;
		/* 修改选框的宽度 */
		height: 16px;
		/* 修改选框的高度 */
		border-color: black;
	}

	.el-checkbox :deep(.el-checkbox__input.is-checked .el-checkbox__inner),
	.el-checkbox :deep(.el-checkbox__input.is-indeterminate .el-checkbox__inner) {
		background-color: black;
		/* 你想要的选中颜色 */
		border-color: black;
	}

	/* 修改选中时的对勾颜色 */
	.el-checkbox :deep(.el-checkbox__input.is-checked .el-checkbox__inner::after) {
		color: black;
		/* 对勾颜色 */
	}

	.draggable {
		position: relative;
		margin-top: 25px;
		width: 250px;
		/*height: 10%;*/
		cursor: pointer;
		background-color: rgb(255, 180, 17);
		color: black;
		border: 1px solid rgb(255, 180, 17);
		text-align: left;
		border-radius: 10px;
		/* 设置圆角的半径 */
		font-size: v-bind(paperFontSize);

		/*line-height: 100px;*/
		/*z-index: 10;*/
	}

	/*.draggable:hover {*/
	/*  transform: translate(20px, 20px);*/
	/*}*/

	.div-recognize-bordered-item {
		position: absolute;
		border: 3px solid rgb(17, 163, 17);
		box-shadow: inset 0 0 10px #4dff00, 0 0 10px #4dff00db;
		padding: 10px;
		margin: 0;
		cursor: default;
    box-sizing: border-box;
	}

	.div-recognize-selected {
		/*border-color: lightgreen;*/
		background-color: #00ff0075;
	}

	.div-pre-modify-bordered-item {
		position: absolute;
		padding: 10px;
		margin: 5px;
		cursor: default;
		transition: opacity 1s;
	}

	.div-operation-bordered-item {
		position: absolute;
		padding: 10px;
		margin: 5px;
		cursor: default;
	}

	.el-card-class {
		width: 96%;
	}

	/*.volume {*/
	/*  text-align: center;*/
	/*  font-size: 12px;*/
	/*}*/
	/*.volume-span {*/
	/*  display: inline-block;*/
	/*  margin-left: 2px;*/
	/*  width: 4px;*/
	/*  height: 20px;*/
	/*  background: #c6e2ff;*/
	/*}*/
</style>
